import AppConstants from '../../Constants/AppConstants';

const keyFor = props => `arcticwhale:${AppConstants.tenantName || 'current-tenant'}:${AppConstants.userId || 'current-user'}:listing-addons:${props?.type || 'listings'}:${props?.isEdit ? `edit-${props?.addonsData?.id || 'unknown'}` : 'new'}`;
const safeImage = value => {
  if (typeof value === 'string') return value.length <= 700000 ? value : '';
  if (!value || typeof value !== 'object') return '';
  const base64 = typeof value.base64 === 'string' && value.base64.length <= 700000 ? value.base64 : undefined;
  const name = value.fileList?.[0]?.name;
  const type = value.fileList?.[0]?.type;
  return base64 ? {base64, ...(typeof name === 'string' ? {fileList: [{name: name.slice(0, 300), type: typeof type === 'string' ? type.slice(0, 100) : ''}]} : {})} : '';
};
const sanitize = value => ({
  title: typeof value?.title === 'string' ? value.title.slice(0, 300) : '',
  status: value?.status !== false,
  selectedImage: safeImage(value?.selectedImage),
  numberFieldArray: (Array.isArray(value?.numberFieldArray) ? value.numberFieldArray : []).slice(0, 4).map(item => String(item ?? '').slice(0, 100)),
});

export const readAddonDraft = props => {
  try {
    if (typeof window === 'undefined' || !window.localStorage) return null;
    const value = JSON.parse(window.localStorage.getItem(keyFor(props)) || 'null');
    return value && typeof value === 'object' ? sanitize(value) : null;
  } catch (error) { return null; }
};
export const writeAddonDraft = (props, values) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) window.localStorage.setItem(keyFor(props), JSON.stringify(sanitize(values)));
  } catch (error) { /* Keep the form usable when browser storage is unavailable or full. */ }
};
export const clearAddonDraft = props => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) window.localStorage.removeItem(keyFor(props));
  } catch (error) { /* Ignore storage errors after save or explicit cancel. */ }
};
